import getQuantity from '../lib/getQuantity';
import useCheckoutState from './useCheckoutState';

export default function useQuantity() {
  const { form } = useCheckoutState();

  if (!form) return null;

  const { fields } = form;

  const quantity = getQuantity(fields);

  return quantity;
}
